import type { BrandingSettings, ThemeSettings, UISettings } from '@/contexts/SiteSettingsContext';

export function isThemeEqual(a: ThemeSettings, b: ThemeSettings): boolean {
  return (
    a.primary_color === b.primary_color &&
    a.accent_color === b.accent_color &&
    a.success_color === b.success_color &&
    a.warning_color === b.warning_color &&
    a.sidebar_bg_color === b.sidebar_bg_color &&
    a.is_dark_mode === b.is_dark_mode
  );
}

export function isBrandingEqual(a: BrandingSettings, b: BrandingSettings): boolean {
  return (
    (a.site_title ?? '') === (b.site_title ?? '') &&
    (a.logo_url ?? null) === (b.logo_url ?? null) &&
    (a.favicon_url ?? null) === (b.favicon_url ?? null) &&
    (a.loading_image_url ?? null) === (b.loading_image_url ?? null)
  );
}

export function isUiEqual(a: UISettings, b: UISettings): boolean {
  return (
    (a.enable_animations !== false) === (b.enable_animations !== false) &&
    (a.enable_glass_effect !== false) === (b.enable_glass_effect !== false) &&
    (a.loading_animation_type ?? 'default') === (b.loading_animation_type ?? 'default') &&
    (a.loader_indicator_duration_ms ?? 1000) === (b.loader_indicator_duration_ms ?? 1000)
  );
}
